<template>
    <div v-if="authStore.amIAdmin()" class="flex flex-wrap justify-content-center admin-view">
        <div v-if="!!senderIncidence && !!senderIncidence.reporter && !!senderIncidence.timestamp">
            <div>
                <span>{{ senderIncidence.reporter.fullName }}</span>,
                <span style="margin: 0 5px 0 5px;">{{ utils.formatDate(senderIncidence.timestamp) }}</span>
            </div>
            <Textarea style="width: 100%;" v-model="senderIncidence.detail" disabled rows="2" />
        </div>
        <div v-if="!!receiverIncidence && !!receiverIncidence.reporter && !!receiverIncidence.timestamp">
            <div>
                <span>{{ receiverIncidence.reporter.fullName }}</span>,
                <span style="margin: 0 5px 0 5px;">{{ utils.formatDate(receiverIncidence.timestamp) }}</span>
            </div>
            <Textarea style="width: 100%;" v-model="receiverIncidence.detail" disabled rows="2" />
        </div>
    </div>
    <div v-else class="flex flex-wrap justify-content-center user-view" style="direction: rtl;">
        <div v-if="viewOnly !== true">{{ $t('REGISTER_INCIDENCE_MESSAGE') }}</div>
        <div v-if="!!timestamp">
            <span style="margin: 0 5px 0 5px;">{{ utils.formatDate(timestamp) }}</span>
        </div>
        <Textarea style="width: 100%;" v-model="details" rows="2" maxlength="500" :disabled="viewOnly" />
        <Button v-if="shouldShowRegisterIncidenceButton" :disabled="!canRegisterIncidence" :label="$t('REGISTER_INCIDENCE')"
            @click="registerIncidence" />
    </div>
</template>

<script setup>
import { ref, inject, onBeforeMount, onBeforeUnmount, computed } from 'vue'
import { useGlobalStore } from '@/stores/global'
import { useAuthStore } from '@/stores/auth'
import operationService from '@/service/OperationService'
import userService from '@/service/UserService'
import utils from '@/helpers/Utils'

const dialogRef = inject("dialogRef")
const globalStore = useGlobalStore()
const authStore = useAuthStore()
const emit = defineEmits(['incidence-registered', 'incidence-register-failed'])

const operation = ref()
const viewOnly = ref(false)
const details = ref()
const timestamp = ref()
const senderIncidence = ref({})
const receiverIncidence = ref({})

onBeforeMount(() => {
    globalStore.registerDialog(dialogRef.value)
    operation.value = dialogRef.value.data.operation
    if (authStore.amIAdmin()) {
        if (operation.value.senderIncidence !== null && operation.value.senderIncidence !== undefined) {
            senderIncidence.value = operation.value.senderIncidence
            userService.decorate([senderIncidence.value.reporter])
        } if (operation.value.receiverIncidence !== null && operation.value.receiverIncidence !== undefined) {
            receiverIncidence.value = operation.value.receiverIncidence
            userService.decorate([receiverIncidence.value.reporter])
        }
    } else if (operation.value.sender.id === authStore.user.id && operation.value.senderIncidence !== null && operation.value.senderIncidence !== undefined) {
        viewOnly.value = true
        details.value = operation.value.senderIncidence.detail
        timestamp.value = operation.value.senderIncidence.timestamp
    } else if (operation.value.receiver.id === authStore.user.id && operation.value.receiverIncidence !== null && operation.value.receiverIncidence !== undefined) {
        viewOnly.value = true
        details.value = operation.value.receiverIncidence.detail
        timestamp.value = operation.value.receiverIncidence.timestamp
    }
})

onBeforeUnmount(() => {
    globalStore.removeDialog(dialogRef.value)
})

const shouldShowRegisterIncidenceButton = computed(() => {
    return viewOnly.value !== true
})

const canRegisterIncidence = computed(() => {
    return details.value !== undefined && details.value !== null && details.value.length > 0
})

const registerIncidence = async () => {
    try {
        const response = await operationService.registerIncidence(operation.value.id, details.value)
        emit('incidence-registered', response.result)
        dialogRef.value.close()
    } catch (e) {
        emit('incidence-register-failed', e)
    }
}

</script>

<style scoped>
.admin-view {
    direction: rtl;
}

.admin-view>* {
    margin-top: 10px;
}

.user-view>* {
    margin-top: 10px;
}
</style>